import React from "react";
import { Link } from "react-router-dom";
import "../../../App.css";
import { getBlogAuthor } from "./blogAuthors";

const parseParagraphs = (body = "") => {
  const raw = String(body || "").trim();
  const paragraphRegex = /<p>([\s\S]*?)<\/p>/g;
  const paragraphs = [];
  let match;

  while ((match = paragraphRegex.exec(raw)) !== null) {
    const value = String(match[1] || "").trim();
    if (value) paragraphs.push(value);
  }

  if (paragraphs.length > 0) return paragraphs;

  return raw
    .split(/\n{2,}/)
    .map((line) => line.trim())
    .filter(Boolean);
};

const renderMarkdownLinks = (text) => {
  const parts = [];
  const linkRegex = /\[([^\]\n]{1,160})\]\((https:\/\/[^\s)<>"']{1,2048})\)/g;
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      <a
        key={`${match[2]}-${match.index}`}
        href={match[2]}
        className="blog-post-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        {match[1]}
      </a>
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

const BlogPostView = ({ post, showBottomButtons = true, preview = false }) => {
  if (!post) {
    return (
      <div className="blog-shell">
        <div className="blog-post-panel">
          <p className="blog-error">Post unavailable.</p>
        </div>
      </div>
    );
  }

  const author = getBlogAuthor(post.author);
  const paragraphs = parseParagraphs(post.body || post.text);

  return (
    <article className="blog-shell" aria-label={preview ? "Blog post preview" : post.title}>
      <div className="blog-post-panel">
        {post.imageUrl || post.image ? (
          <img
            src={post.imageUrl || post.image}
            alt=""
            className="blog-post-hero"
            loading={preview ? "eager" : "lazy"}
          />
        ) : null}

        <div className="blog-post-category">{post.category || "Uncategorised"}</div>
        <h1 className="blog-post-title">{post.title || "Untitled Post"}</h1>

        <div className="blog-post-author-row">
          <img src={author.avatar} alt="" className="blog-author-avatar" />
          <span className="blog-post-author-name">{author.label}</span>
        </div>

        <div className="blog-post-date">{post.date || "No date supplied"}</div>

        <div className="blog-post-body">
          {paragraphs.map((paragraph, index) => (
            <p key={`${index}-${paragraph.slice(0, 18)}`}>
              {renderMarkdownLinks(paragraph)}
            </p>
          ))}
        </div>

        {showBottomButtons ? (
          <nav className="blog-post-bottom-nav" aria-label="Blog post navigation">
            <Link to="/blog" className="blog-nav-button">Back to Blog</Link>
            <Link to="/home" className="blog-nav-button">Home</Link>
            <Link to="/news" className="blog-nav-button">News</Link>
          </nav>
        ) : null}
      </div>
    </article>
  );
};

export default BlogPostView;
